import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ForgotPassword from "../views/auth/ForgotPassword";
import LogInForm from "../views/auth/LogInForm";
import SignUpForm from "../views/auth/SignUpForm";
import AdminDashboard from "../views/dashboard/admin/AdminDashboard";
import PrivateComponent from "../views/auth/PrivateComponent";
import VerifyAccount from "../views/auth/VerifyAccount";
import ResetPassword from "../views/auth/ResetPassword";
import UserDashboard from "../views/dashboard/user/UserDashboard";
import Profile from "../views/profile/Profile";
import AdminLFCDeposit from "../views/dashboard/admin/AdminLFCDeposit";
// import RoadMap from "../views/dashboard/user/RoadMap";
import Main from "../views/promotional/Main";
import Purchase from "../views/dashboard/user/Purchase";
import TransactionHistory from "../views/dashboard/user/TransactionHistory";
import AdminTransactionHistory from "../views/dashboard/admin/AdminTransactionHistory";
import AdminWithdraw from "../views/dashboard/admin/AdminWithdraw";
import AdminDepositWithdrawHistory from "../views/dashboard/admin/AdminDepositWithdrawHistory";
import AdminToken from "../views/dashboard/admin/token/AdminToken";
import AdminSettings from "../views/dashboard/admin/settings/AdminSettings";
import AdminUserManagement from "../views/dashboard/admin/AdminUserManagement";
import AdminWalletChangeRequests from "../views/dashboard/admin/AdminWalletChangeRequests";
import HelpSection from "../views/dashboard/user/HelpSection";
import AdminTokenInitialization from "../views/dashboard/admin/token/AdminTokenInitialization";
import Community from "../views/promotional/Community/Community";
import ReadFullArticle from "../views/promotional/Community/ReadFullTopStories/ReadFullArticle";
import AboutUs from "../views/promotional/AboutUs/AboutUs";
import TermsAndConditions from "../views/promotional/TermsAndConditions/TermsAndConditions";
import PrivacyAndPolicy from "../views/promotional/PrivacyAndPolicy/PrivacyAndPolicy";
import FrequentlyAskedQuestions from "../views/promotional/FrequentlyAsked/FrequentlyAskedQuestions";
import GamesRules from "../views/promotional/Community/PlayingGames/GamesRules";
import AdminAirdropUsers from "../views/dashboard/admin/AdminAirdropUsers";
import AdminWithdrawalToken from "../views/dashboard/admin/AdminWithdrawalToken";
import AdminInitializationHistory from "../views/dashboard/admin/token/AdminInitializationHistory";
// import WelcomeMain from "../views/dashboard/admin/welcomeSports/WelcomeMain";
// import HandleTwitterAccounts from "../views/dashboard/admin/HandleTwitterAcconts/HandleTwitterAccounts";
import Events from "../views/promotional/Events/Events";
import Logout from "../views/LogOut/Logout";

const RouterPage = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Main />} />
          {/* <Route path="/login" element={<LogInForm />} /> */}
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/privacy-and-Policy" element={<PrivacyAndPolicy />} />
          <Route
            path="/frequently-asked-questions"
            element={<FrequentlyAskedQuestions />}
          />
          {/* <Route path="/sign-up" element={<SignUpForm />} /> */}
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          {/* <Route path="/verify-account/:token" element={<VerifyAccount />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} /> */}
          <Route path="/launchparty" element={<Main />} />
          <Route path="/community" element={<Community />} />
          <Route path="/events" element={<Events  />} />
          <Route path="/article/:storyId" element={<ReadFullArticle />} />
          <Route path="/games-rules/:id" element={<GamesRules />} />
          <Route element={<PrivateComponent />}>
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/user-dashboard" element={<UserDashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin-lfc-deposit" element={<AdminLFCDeposit />} />
            <Route path="/admin-lfc-withdraw" element={<AdminWithdraw />} />
            {/* <Route path="/roadmap" element={<RoadMap />} /> */}
            {/* <Route path="/article" element={<ReadFullArticle />} /> */}
            <Route path="/purchase" element={<Purchase />} />
            <Route
              path="/transaction-history"
              element={<TransactionHistory />}
            />
            <Route
              path="/admin-transaction-history"
              element={<AdminTransactionHistory />}
            />
            <Route
              path="/admin-deposit-withdraw-history"
              element={<AdminDepositWithdrawHistory />}
            />
            <Route path="/admin-create-liquidity" element={<AdminToken />} />
            <Route path="/admin-settings" element={<AdminSettings />} />
            <Route
              path="/admin-user-management"
              element={<AdminUserManagement />}
            />
            <Route
              path="/admin-requests"
              element={<AdminWalletChangeRequests />}
            />
            <Route path="/help" element={<HelpSection />} />
            <Route
              path="/admin-token-initialize"
              element={<AdminTokenInitialization />}
            />
            <Route path="/airdrop-users" element={<AdminAirdropUsers />} />
            <Route
              path="/withdrawal-token"
              element={<AdminWithdrawalToken />}
            />
            <Route
              path="/admin-init-history"
              element={<AdminInitializationHistory />}
            />
            {/* <Route path="/admin-welcome-update" element={<WelcomeMain />} />
            <Route path="/handle-twitter-accounts" element={<HandleTwitterAccounts/>} /> */}
              <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default RouterPage;
